import { useDispatch, useSelector } from "react-redux";
import { USER, USERALL, ROLEALL } from "../../services/actions";
import { useNavigate } from "react-router-dom";
import React from "react";
import { Container, Box, Grid, Pagination, Tabs, Tab, Button } from "@mui/material";
import InfoCard2 from "../extra/InfoCard2";
import Form from "./Form";
import ActionBar from "../extra/ActionBar";
import SearchBar from "../extra/SearchBar";
import XTable from "../extra/XTableAnother";
import { layouts } from "chart.js";
import MoreInfo from "../extra/MoreInfo";
import NoData from "../extra/NoData";

export default function View() {
  let dispatch = useDispatch();
  const navigate = useNavigate()
  const [open, setOpen] = React.useState(false);
  const [defV, setDefV] = React.useState({});
  const [view, setView] = React.useState(1); // Added state for view
  const [isActiveTab, setIsActiveTab] = React.useState(0);
  const [companies, setCompanies] = React.useState([]);
  const [page, setPage] = React.useState(0); // current page
  const pageSize = 20; // number of items per page (your API seems to default to 20)
  const fetchUsers = (page = 0, is_active = isActiveTab === 0) => {
    const url = page === 0 ? `public/user/${page}/?filter_by={"is_active":${is_active}}` : `public/user/?page=${page}&filter_by={"is_active":${is_active}}`; // pass page number
    dispatch({ type: `${USERALL}_GET`, payload: url });
  };

  let roleallState = useSelector((state) => state?.roleallState);
  let userState = useSelector((state) => state?.userState);
  let userallState = useSelector((state) => state?.userallState);
  let user = useSelector((state) => state?.loginState?.auth);

  React.useEffect(() => {
    try {
      dispatch({ type: `${ROLEALL}_GET`, payload: 0 });
    } catch (err) { }
  }, []);

  React.useEffect(() => {
    fetchUsers(page, isActiveTab === 0);
  }, [page, isActiveTab]);

  React.useEffect(() => {
    if (userState.success) {
      setOpen(false);
      fetchUsers(0, isActiveTab === 0)
    }
  }, [userState?.data]);

  const handleSearch = (key, value) => {
    console.log(key, value);
    let isActive = isActiveTab === 0;
    const query = `public/user/0/?filter_by={"${key}__istartswith":"${value}","is_active":${isActive}}`;
    dispatch({ type: `${USERALL}_GET`, payload: query });
  };

  // Prepare data for XTable
  const tableHeadings = [
    "ID",
    "Image",
    "First Name",
    "Username",
    "Role",
    "Company",
    "Status",
  ];
  const tableRows = userallState?.data?.results?.map((user) => ({
    id: user.id, // Include ID to find the original data on edit
    image: user.avatar,
    first_name: user.first_name,
    last_name: user.last_name,
    username: user.username,
    main_role: user.main_role || (user.group && user.group[0]?.name) || "User",
    group: user.group,
    phone: user.phone,
    country_code: user.country_code,
    project_count: user.company_name,
    is_active: user.is_active ? "Active" : "Inactive",
  }));

  const handleEdit = (data) => {
    console.log("Edit for data:", data);
    const fullUser = userallState?.data?.results?.find((u) => u.id === data.id) || data;
    setDefV(fullUser);
    setOpen(true);
  };

  const handleDelete = (id) => {
    dispatch({ type: `${USER}_DELETE`, payload: id });
  };

  return (
    <>
      {open ? (
        <Box sx={{ p: 2 }}>
          <Form
            roles={roleallState?.data?.results}
            defaultValues={defV}
            onSubmit={(data) => {
              let payload = {}
              if (data.id) {
                payload.id = data.id
              }
              payload.password = '0000'
              payload.username = data.username
              payload.first_name = data.first_name
              payload.last_name = data.last_name
              payload.country_code = data.country_code
              payload.phone = data.phone
              let role = Array.isArray(data?.group) ? data.group.map(v => v?.name || v) : (data?.group ? [data.group.name || data.group] : [])
              payload.main_role = role[0]
              payload.group = role
              console.log("Data", payload)
              let ACTION = payload.id ? `${USER}_PATCH` : `${USER}_POST`;
              dispatch({ type: ACTION, payload: payload });
            }}
            onChange={(action, value) => {
              if (value) {
                // dispatch({
                //   type: `${PROJECT}_GET`,
                //   payload: `project/0/?filter_by={"company":"${value}"}`,
                // });
              }
            }}
            back={() => {
              setOpen(false);
            }}
          />
        </Box>
      ) : (
        <Container maxWidth="false" className="py-3">
          <ActionBar
            showGrid={[2, 5]}
            btnImport="Import Employee"
            onBtnClick={(type, col) => {
              if (type === "grid") {
                setView(1);
              }
              if (type === "tabular") {
                setView(2);
              }
              if (type = "import") {
                navigate('/users-csv/', {
                  state: {
                    data: {},
                    title: "User", prevNav: '/user-management/'
                  }
                })
              }
            }}
            hasPermission={user?.permissions?.includes("authentic.add_user")}
            label="Employee"
            setOpen={(s) => {
              setDefV({}); // Reset default values
              setOpen(true);
            }}
            btnLabel="ADD EMPLOYEE"

          />

          <SearchBar bylist={["first_name", "main_role"]} handleSearch={handleSearch} />

          <Box sx={{ borderBottom: 1, borderColor: 'divider', mb: 2, display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 2 }}>
            <Tabs value={isActiveTab} onChange={(e, val) => { setIsActiveTab(val); setPage(0); }} aria-label="user status tabs">
              <Tab label="Active Users" />
              <Tab label="Deactivated Users" />
            </Tabs>
          </Box>

          {view === 1 && (
            <>
              {!userallState?.data?.results || userallState?.data?.results?.length === 0 ? (
                <NoData title="No Employees Found" message="There are currently no employees to display. Try adjusting your search filters or add a new employee." />
              ) : (
                <>
                  <Grid container spacing={1}>
                    {userallState?.data?.results?.map((data) => {
                      data.image = user;
                      // data.project_count = data.projects?.length; // Added project count for display
                      return (
                        <Grid alignItems="stretch" size={{ xs: 12, sm: 4, md: 3, lg: 3, xl: 3, xxl: 2 }}>
                          <InfoCard2
                            sx={{
                              height: 300, // Use the prop, or a default value
                            }}
                            type="user"
                            keys={[
                              "image",
                              "first_name",
                              "username",
                              "main_role",
                              "Works",
                              "project_count",
                              "Completed",
                              "timelapse_camera_count",
                              "Pending",
                              "live_camera_count",
                              "last_name",
                            ]}
                            data={data}
                            onClick={() => {
                              //navigate("/timelapse-preview/", {})
                            }}
                            onAction={(action, data) => {
                              if (action == "Edit") {
                                handleEdit(data); // Call the shared edit handler
                              } else if (action == "Delete") {
                                handleDelete(data.id); // Call the shared delete handler
                              } else if (action == "More") {
                                setDefV(data);
                                setView(3);
                              } else if (action == "Status") {
                                let payload = {
                                  id: data.id,
                                  is_active: !data.is_active
                                };
                                dispatch({ type: `${USER}_PATCH`, payload: payload });
                              }
                            }}
                          />
                        </Grid>
                      );
                    })}
                  </Grid>
                  <Box sx={{ display: "flex", justifyContent: "center", mt: 2 }}>
                    <Pagination
                      count={Math.ceil(userallState?.data?.count / pageSize)}
                      page={page}
                      onChange={(e, value) => setPage(value)}
                      color="primary"
                    />
                  </Box>
                </>
              )}
            </>
          )}

          {view === 2 && (
            <XTable
              head={tableHeadings}
              rows={tableRows}
              onEdit={handleEdit} // Use the shared handler
              onDelete={handleDelete} // Use the shared handler
            />
          )}
          {view === 3 && (
            <MoreInfo
              data={{
                ...defV,
                is_active: defV.is_active ? "Yes" : "No",
                // verify: defV.verify ? "Yes" : "No",
              }}
              skip={[
                "avatar",
                "address",
                "refresh_token",
                "token",
                "is_social_login",
                "shared_key",
                "whatsapp_number"

              ]}
              group={["first_name", "last_name", "username", "created_at"]}
              // icons={{ access_loation: <BsCopy /> }}
              // css={{ access_location: { color: '#1976d2' } }}
              onClose={() => {
                setView(1);
              }}
            />
          )}
        </Container>
      )}
    </>
  );
}
